module.exports = __webpack_public_path__ + "fb982ea46bdbfca34f67e6ee83f28d30.svg";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Light.svg
// module id = 357
// module chunks = 0